export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/email-capture-notfound.b0c911fc.gif","height":500,"width":500};